import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 9143 12633"
    {...props}
  >
    <path
      d="M9058 12254c-160-181-405-479-464-768L7068 4136c-3-13-3-28-5-41-181 38-364 62-548 62-248 0-498-34-743-104-549-157-1022-478-1370-918L2939 6633l-1396 4316c-90 280-382 405-618 229-168-126-358-291-554-511-196-219-371-180-371 115 0 409 69 972 386 1363 83 104 197 198 308 275 186 133 592 213 887 213h6142c293 0 501-265 259-433-290-201-756-318-1118-382-290-52-528-138-532-221-3-80-9-148-18-148h-11c-6 0-11-111-34-246-12-71-30-152-58-240-2-8-5-34-7-42-5-14-10-38-16-52-51-139-113-272-184-391-250-415-717-895-1587-1252-273-112-461-253-409-346s327-114 602-9c355 134 835 367 1241 736 218 198 426 165 509-118l112-379c84-282 226-284 318-5l692 2100c92 280 402 564 656 714 109 63 217 141 307 236 202 215 345 478 516 478s258-198 97-379zM4520 2852 5631 195c114-272 248-258 301 33l1 5c53 289 334 533 629 544l1915 72c294 11 466 249 385 532l-101 350c-82 284-354 634-595 803-246 172-559 410-846 687-143 138-233 376-260 605-396 92-812 85-1214-30-544-155-1007-487-1326-944z"
      style={{
        fill: "#292525",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
